export default __webpack_public_path__ + "static/media/bubbles-2.c0051cc0.png";